import {
  addDoc,
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
  where,
  doc,
} from "firebase/firestore";
import { ACTIONS, writeLog } from "./auditService";
import { db } from "./firebase";

export async function submitAccessRequest(actor, reason) {
  const existing = await getPendingRequestForUser(actor.uid);
  if (existing) {
    const error = new Error("A pending request already exists");
    error.code = "access/request-already-pending";
    throw error;
  }

  const request = {
    uid: actor.uid,
    email: actor.email,
    displayName: actor.displayName,
    reason,
    status: "pending",
    requestedAt: serverTimestamp(),
    reviewedBy: null,
    reviewedAt: null,
  };
  const ref = await addDoc(collection(db, "accessRequests"), request);
  await writeLog(actor, ACTIONS.REQUEST_ACCESS, "accessRequest", ref.id, `Access request: ${actor.displayName}`);
}

export async function listAccessRequests() {
  const q = query(collection(db, "accessRequests"), orderBy("requestedAt", "desc"), limit(200));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function getPendingRequestsCount() {
  const q = query(collection(db, "accessRequests"), where("status", "==", "pending"));
  const snap = await getDocs(q);
  return snap.size;
}

export async function getPendingRequestForUser(uid) {
  const q = query(collection(db, "accessRequests"), where("uid", "==", uid), where("status", "==", "pending"), limit(1));
  const snap = await getDocs(q);
  if (snap.empty) return null;
  const d = snap.docs[0];
  return { id: d.id, ...d.data() };
}

export async function getLatestRequestForUser(uid) {
  const q = query(collection(db, "accessRequests"), where("uid", "==", uid), orderBy("requestedAt", "desc"), limit(1));
  const snap = await getDocs(q);
  if (snap.empty) return null;
  const d = snap.docs[0];
  return { id: d.id, ...d.data() };
}

export async function reviewAccessRequest(request, actor, approved) {
  if (!request?.id) {
    const error = new Error("Missing request id");
    error.code = "access/missing-request-id";
    throw error;
  }
  if (request.status && request.status !== "pending") {
    const error = new Error("Request already reviewed");
    error.code = "access/request-already-reviewed";
    throw error;
  }

  await updateDoc(doc(db, "accessRequests", request.id), {
    status: approved ? "approved" : "rejected",
    reviewedBy: actor.uid,
    reviewedByName: actor.displayName || "",
    reviewedAt: serverTimestamp(),
  });
  if (approved) {
    await updateDoc(doc(db, "users", request.uid), { role: "admin" });
  }
  await writeLog(
    actor,
    approved ? ACTIONS.APPROVE_ACCESS : ACTIONS.REJECT_ACCESS,
    "accessRequest",
    request.id,
    `Access request: ${request.displayName}`
  );
}
